module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#trending",
      toString: function () {
        return this.url;
      }
    }